import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";

const fadeUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6 }
};

export const CTASection = ({ t, userType, openPaymentModal, isLoading, stock }) => {
  const getCtaLabel = () => {
    if (!stock.available) return t("sold_out");
    if (isLoading) return "...";
    return t("cta_btn");
  };

  return (
  <section className="py-12 md:py-24 px-4 md:px-8 relative overflow-hidden">
    <div className="absolute inset-0">
      <img 
        src="https://customer-assets.emergentagent.com/job_mex-catnip-promo/artifacts/i3fh3mkj_flor%20atardecer.png"
        alt=""
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/40"></div>
    </div>
    <div className="max-w-4xl mx-auto text-center relative z-10 px-2">
      <motion.div {...fadeUp}>
        <h2 className="font-gluten text-2xl sm:text-3xl md:text-4xl text-white mb-3 md:mb-4">
          {t("cta_title")}
        </h2>
        <p className="font-nunito text-base sm:text-lg text-white/90 mb-6 md:mb-8 max-w-2xl mx-auto">
          {t("cta_description")}
        </p>
        {userType === "business" && (
          <Button 
            onClick={openPaymentModal}
            disabled={isLoading || !stock.available}
            size="lg"
            className={`w-full sm:w-auto ${stock.available ? 'bg-mexican hover:bg-mexican/90' : 'bg-gray-400 cursor-not-allowed'} text-white font-fredoka font-bold rounded-full px-6 sm:px-10 py-5 sm:py-6 text-base sm:text-lg shadow-xl ${stock.available ? 'hover:shadow-2xl transition-all hover:-translate-y-1' : ''}`}
            data-testid="cta-comprar-btn"
          >
            {getCtaLabel()}
          </Button>
        )}
      </motion.div>
    </div>
  </section>
  );
};
